import { Injectable } from "@angular/core";
import { PublicationModel } from "../interfaces/publication-model";
import { v4 as uuidv4 } from "uuid";
import { TreeNodeModel } from "../interfaces/tree-node-model";

@Injectable({
    providedIn: "root",
})
export class PublicationCloneService {
    clone(source: PublicationModel, newName: string): PublicationModel {
        return {
            ...source,
            id: uuidv4(),
            name: newName,
            sections: this.transformSections(source.sections ?? [], null),
        };
    }

    private transformSections(
        sections: TreeNodeModel[],
        newParentId: string | null,
    ): TreeNodeModel[] {
        return sections.map((section) =>
            this.transformSection(section, newParentId),
        );
    }

    private transformSection(
        section: TreeNodeModel,
        newParentId: string | null,
    ): TreeNodeModel {
        const newId = uuidv4();

        return {
            ...section,
            id: newId,
            parentSection: newParentId,
            sections: section.sections?.length
                ? this.transformSections(
                      section.sections as TreeNodeModel[],
                      newId,
                  )
                : null,
            sectionResources: section.sectionResources?.length
                ? this.transformSectionResources(
                      section.sectionResources as TreeNodeModel[],
                      newId,
                  )
                : null,
        };
    }

    private transformSectionResources(
        resources: TreeNodeModel[],
        newParentId: string,
    ): TreeNodeModel[] {
        return resources.map((resource) => ({
            ...resource,
            id: uuidv4(),
            parentSection: newParentId,
        }));
    }
}
